// Environment imports
import { environment } from '../../environments/environment';

export class URLConstants {
    static ciranetHelpUrl = environment.ciranetHelpUrl;
    static ccApiBaseUrl = environment.ccApiUrl;
    static ccAuthApiBaseUrl = environment.ccApiUrl + 'auth/';
    static ccBrandingApiBaseUrl = environment.ccApiUrl + 'branding/';
    static ccManagementPortalBaseApiUrl = environment.ccManagementPortalApiUrl;
    static ccUserActivityApiUrl = environment.ccApiUrl + 'user/activity';
    static ccUserPortalInfoApiUrl = environment.ccApiUrl + 'user/portalInfo';
    static ccUserSettingsApiUrl = environment.ccApiUrl + 'user/settings';
    static ccUserBaseApiUrl = environment.ccManagementPortalApiUrl + 'user';
    static ccPortalAnnouncementApiUrl = environment.ccManagementPortalApiUrl + 'announcements';
    static ccClosingPortalMakePaymentUrl = environment.closingPortalUrl + 'makepayment';

    static ccWorkflowEditorBaseApiUrl = environment.ccManagementPortalApiUrl + 'wfe/';
    static ccWorkflowViewerBaseApiUrl = environment.ccManagementPortalApiUrl + 'wf/';

    static ccCommunityCBBaseUrl = environment.ccManagementPortalApiUrl + 'cb';
    static ccEntityCCBBaseUrl = environment.ccManagementPortalApiUrl + 'ccb';

    static ccSeachBaseApiUrl = environment.ccManagementPortalApiUrl + 'search';
    static ccOwnerApiBaseUrl = environment.ccManagementPortalApiUrl + 'owner/';
    static ccCommunityApiBaseUrl = environment.ccManagementPortalApiUrl + 'community/';
    static ccOwnerCollectionApiBaseUrl = environment.ccManagementPortalApiUrl + 'owner/collection';
    static ccTransitionChecklistApiBaseUrl = environment.ccManagementPortalApiUrl + 'community/transition/checklist';
    static ccBoardMembersBaseUrl = environment.ccManagementPortalApiUrl + 'community/board-members';

    static ccVendorAccountBaseApiUrl = environment.ccManagementPortalApiUrl + 'vaa';

    static ccLotUnitBaseApiUrl = environment.ccManagementPortalApiUrl + 'tools/lotunit';
    static ccUserSetupBaseApiUrl = environment.ccManagementPortalApiUrl + 'tools/usersetup';

    static ccVendorImportBaseApiUrl = environment.ccManagementPortalApiUrl + 'tools/vendorimport';
    static ccAchImportBaseApiUrl = environment.ccManagementPortalApiUrl + 'tools/achimport';
    static ccCorpInvoiceUploadBaseApiUrl = environment.ccManagementPortalApiUrl + 'tools/corpinvoiceupload';
    static ccPortalUserManagementBaseApiUrl = environment.ccManagementPortalApiUrl + 'tools/portalusermanagement';
    static ccLocationManagementBaseApiUrl = environment.ccManagementPortalApiUrl + 'tools/location-management';
    static ccAttorneyManagementBaseApiUrl = environment.ccManagementPortalApiUrl + 'tools/attorney-mgmt';
    static ccLocationSatelliteOfficeManagementBaseApiUrl =
        environment.ccManagementPortalApiUrl + 'tools/location-satellite-office-management';
    static ccBankingPartnerLocationRemitToAddressBaseApiUrl =
        environment.ccManagementPortalApiUrl + 'tools/banking-partner-location-remit-to-address';

    static ccLotLoadImportBaseApiUrl = environment.ccManagementPortalApiUrl + 'tools/lotloadimport';
    static ccARLoadBaseApiUrl = environment.ccManagementPortalApiUrl + 'tools/arload';
    static ccManageMyProfileBaseApiUrl = environment.ccManagementPortalApiUrl + 'tools/userprofile';
    static ccApplicationInstallsBaseApiUrl = environment.ccManagementPortalApiUrl + 'tools/app-installs';

    static propertyOneTimePaymentResultUrl = environment.ccManagementPortalApiUrl + 'accounts/one-time-payment/';
    static propertyOneTimePaymentResultIntegratedUrl =
        environment.portalSelectionUrl + '/managementportal/assets/html/';

    static ccCBBatchApiBaseUrl = environment.ccManagementPortalApiUrl + 'cb/batch';
    static ccCBConfigApiBaseUrl = environment.ccManagementPortalApiUrl + 'cb/config';
    static ccCBEntityConfigApiBaseUrl = environment.ccManagementPortalApiUrl + 'cb/config/entity';
    static ccCBGLConfigApiBaseUrl = environment.ccManagementPortalApiUrl + 'cb/config/gl';
    static ccCBCustomerApiBaseUrl = environment.ccManagementPortalApiUrl + 'cb/customer';
    static ccCBCustomerCategoryApiBaseUrl = environment.ccManagementPortalApiUrl + 'ccb/rm/setup/customer-category';
    static ccCBContractFormSetupApiBaseUrl = environment.ccManagementPortalApiUrl + 'ccb/rm/setup/contract-form';

    static ccEmailApiBaseUrl = environment.ccManagementPortalApiUrl + 'email';
    static ccLogACallBaseApi = environment.ccManagementPortalApiUrl + 'tools/logacall';
    static ccManagePropertyBaseUrl = environment.ccManagementPortalApiUrl + 'tools/manageproperty/step';
    static ccManagePropertyOwnerBaseUrl = environment.ccManagementPortalApiUrl + 'tools/manageproperty/step/owner';

    static ccBillingRuleAssignmentApiUrl = environment.ccManagementPortalApiUrl + 'br/assignments';
    static ccBillingRuleCommunitiesApiUrl = environment.ccManagementPortalApiUrl + 'br/communities';
    static ccBillingRulesApiUrl = environment.ccManagementPortalApiUrl + 'billingrule';
    static ccBillingLateFeeRulesApiUrl = environment.ccManagementPortalApiUrl + 'billingrule/latefee';

    static ccCiramailBaseApiUrl = environment.ccManagementPortalApiUrl + 'ciramail';
    static ccCiramailTemplateConfigApiUrl = environment.ccManagementPortalApiUrl + 'ciramail/config/template';
    static ccAIEmailContentBaseUrl = `${environment.ccManagementPortalApiUrl}/ai/email-content`;

    static ccAssessmentRuleAssignmentApiUrl = environment.ccManagementPortalApiUrl + 'ar/assignments';
    static ccAssessmentRuleCommunitiesApiUrl = environment.ccManagementPortalApiUrl + 'ar/communities';

    static ccLocationBaseUrl = environment.ccManagementPortalApiUrl + 'location';

    static ccCBCMCRBaseApiURL = environment.ccManagementPortalApiUrl + 'cb/cm/cr';
    static ccCBCMDepositsApiBaseUrl = environment.ccManagementPortalApiUrl + 'cb/cm/dep';
    static ccCBCMBankStatementBaseUrl = environment.ccManagementPortalApiUrl + 'cb/cm/mbs';
    static ccCBBankAccountsApiBaseUrl = environment.ccManagementPortalApiUrl + 'cb/cm/ba';
    static ccCBBankReconciliationBaseUrl = environment.ccManagementPortalApiUrl + 'cb/cm/ba/bankrec';
    static ccCBLockboxPaymentFileApiBaseUrl = environment.ccManagementPortalApiUrl + 'cb/cm/lpf';
    static ccCBUnmatchedTransactionsApiBaseUrl = environment.ccManagementPortalApiUrl + 'cb/cm/unmatchedtransactions';
    static ccCBFundsTransferApiBaseUrl = environment.ccManagementPortalApiUrl + 'cb/cm/ft';

    static ccCBAPUnappliedPaymentsUrl = environment.ccManagementPortalApiUrl + 'cb/ap/unappliedpayments';
    static ccCBAPVendorAgingUrl = environment.ccManagementPortalApiUrl + 'cb/ap/aging/report';
    static ccCBAPLedgerApiUrl = environment.ccManagementPortalApiUrl + 'cb/ap/ledger';
    static ccCBAPBillApiUrl = environment.ccManagementPortalApiUrl + 'cb/ap/bill';
    static ccCBAPAdjustmentApiUrl = environment.ccManagementPortalApiUrl + 'cb/ap/adjustment';
    static ccCBAPPaymentApiUrl = environment.ccManagementPortalApiUrl + 'cb/ap/payment';
    static ccCBAPEFTPaymentManagementApiUrl = environment.ccManagementPortalApiUrl + 'cb/ap/eftmgmt';
    static ccCBAPBillAnalysisApiUrl = environment.ccManagementPortalApiUrl + 'cb/ap/billanalysis';
    static ccCBAPVendor1099ApiUrl = environment.ccManagementPortalApiUrl + 'cb/ap/1099';
    static ccCBAPBaseApiUrl = environment.ccManagementPortalApiUrl + 'cb/ap';
    static ccCCBAPBillsToPayUrl = environment.ccManagementPortalApiUrl + 'ccb/ap/bill-pay';

    static ccCBARBaseApiUrl = environment.ccManagementPortalApiUrl + 'cb/ar';
    static ccCBARAdjustmentApiUrl = environment.ccManagementPortalApiUrl + 'cb/ar/adjustment';
    static ccCBARLedgerApiUrl = environment.ccManagementPortalApiUrl + 'cb/ar/ledger';
    static ccCBARPaymentApiUrl = environment.ccManagementPortalApiUrl + 'cb/ar/payment';
    static ccCBARMassUploadApiUrl = environment.ccManagementPortalApiUrl + 'cb/ar/massupload';
    static ccARInvoiceAnalysisApiUrl = environment.ccManagementPortalApiUrl + 'cb/ar/invoiceAnalysis';
    static ccCBARAgingApiUrl = environment.ccManagementPortalApiUrl + 'cb/ar/aging/report';
    static ccInvoiceApiUrl = environment.ccManagementPortalApiUrl + 'cb/ar/invoice';
    static ccCBARLotPaymentApiUrl = environment.ccManagementPortalApiUrl + 'cb/ar/lot-payment';
    static ccCBARCollectionsApiUrl = environment.ccManagementPortalApiUrl + 'cb/ar/collections';
    static ccCBARBuilderStatementApiUrl = environment.ccManagementPortalApiUrl + 'cb/ar/builder-statement';
    static ccCBARAssessmentRuleApiUrl = environment.ccManagementPortalApiUrl + 'cb/ar/assessmentrules';
    static ccAssessmentRuleApiUrl = environment.ccManagementPortalApiUrl + 'assessmentrules';
    static ccOwnerAssessmentRuleApiUrl = environment.ccManagementPortalApiUrl + 'owner/assessmentrules';
    static ccOwnerBillingRuleApiUrl = environment.ccManagementPortalApiUrl + 'owner/billingrule';

    static ccCBGLTrialBalanceApiUrl = environment.ccManagementPortalApiUrl + 'cb/gl/trialbalance';
    static ccCBGLReportBaseApiUrl = environment.ccManagementPortalApiUrl + 'cb/gl';
    static ccCBGLReportApiUrl = environment.ccManagementPortalApiUrl + 'cb/gl/report';
    static ccCBGLBudgetApiUrl = environment.ccManagementPortalApiUrl + 'cb/gl/budget';
    static ccCBGLJETemplatesApiUrl = environment.ccManagementPortalApiUrl + 'cb/gl/jet';
    static ccCBGLJournalEntryApiUrl = environment.ccManagementPortalApiUrl + 'cb/gl/je';
    static ccCBGLBatchApiUrl = environment.ccManagementPortalApiUrl + 'cb/gl/batch';

    static cirahelpApiUrl = environment.ccManagementPortalApiUrl + 'cirahelp';
    static ccReportsApiUrl = environment.ccManagementPortalApiUrl + 'rep';
    static ccFinActualVsBudgetApiUrl = environment.ccManagementPortalApiUrl + 'rep/fin/actualvsbudget';
    static ccFRFinancialSummaryApiUrl = environment.ccManagementPortalApiUrl + 'rep/financialsummary';
    static ccFinBenchmarkReportApiUrl = environment.ccManagementPortalApiUrl + 'rep/benchmark';
    static ccCBGLOpenCloseBooksApiUrl = environment.ccManagementPortalApiUrl + 'cb/entity/books';

    static ccCheckPrintingConfigApiUrl = environment.ccManagementPortalApiUrl + 'checkprinting/config/localoffice';
    static ccCheckPrintingManagementApiUrl = environment.ccManagementPortalApiUrl + 'checkprinting/management';

    static ccConfigBaseUrl = environment.ccManagementPortalApiUrl + 'config';
    static ccViolationConfigBaseUrl = environment.ccManagementPortalApiUrl + 'config/violation';
    static ccEnforcementConfigBaseUrl = environment.ccManagementPortalApiUrl + 'config/enforcement';
    static ccCommunityConfigGroupBaseUrl = environment.ccManagementPortalApiUrl + 'config/community-group';
    static ccCommunityConfigBaseUrl = environment.ccManagementPortalApiUrl + 'config/community';
    static caAccountingBaseUrl = environment.ccManagementPortalApiUrl + 'config/ca-accounting';
    static miscInvoiceTypeConfigBaseUrl = environment.ccManagementPortalApiUrl + 'config/misc-invoice-type';
    static ccCollectionsConfigBaseUrl = environment.ccManagementPortalApiUrl + 'config/collections';
    static ccCommunityVendorBaseApiUrl = environment.ccManagementPortalApiUrl + 'va';
    static ccClosingPortalConfigBaseApiUrl = environment.ccManagementPortalApiUrl + 'config/closingportal';
    static ccDeliveryTierConfigBaseApiUrl =
        environment.ccManagementPortalApiUrl + 'config/closingportal/delivery-tiers';
    static ccCiraConnectFeeConfigBaseApiUrl =
        environment.ccManagementPortalApiUrl + 'config/closingportal/cira-connect-fee';
    static ccFeeChargeConfigBaseApiUrl =
        environment.ccManagementPortalApiUrl + 'config/closingportal/portal-fee-charge';
    static ccAccountInquiryFulfillmentConfigBaseApiUrl =
        environment.ccManagementPortalApiUrl + 'config/closingportal/account-inquiry-fulfillment';
    static ccBoardApprovalConfigBaseUrl = environment.ccManagementPortalApiUrl + 'config/boardapproval';
    static ccInfoConfigBaseUrl = environment.ccManagementPortalApiUrl + 'config/community/info';
    static ccAccConfigBaseUrl = environment.ccManagementPortalApiUrl + 'config/architectural';
    static ccPaoConfigBaseApiUrl = environment.ccManagementPortalApiUrl + 'config/pao';
    static builderConfigBaseUrl = environment.ccManagementPortalApiUrl + 'config/builder';
    static ccNotesConfigBaseUrl = environment.ccManagementPortalApiUrl + 'config/note';
    static ccFinancialCongigBaseApiUrl = environment.ccManagementPortalApiUrl + 'config/cf';
    static ccProcessTrackerConfigBaseApiUrl = environment.ccManagementPortalApiUrl + 'config/process-tracker';
    static ccTransitionConfigBaseApiUrl = environment.ccManagementPortalApiUrl + 'config/transition';
    static ccModulesConfigBaseApiUrl = environment.ccManagementPortalApiUrl + 'config/modules';
    static ccEgnyteConfigBaseApiUrl = environment.ccManagementPortalApiUrl + 'config/egnyte';
    static ccAapWfAutoActionConfigBaseApiUrl = environment.ccManagementPortalApiUrl + 'config/aap-wf/auto-action';
    static ccAapWfChecklistConfigBaseApiUrl = environment.ccManagementPortalApiUrl + 'config/aap-wf/check-list';
    static ccAapCrossEntityBillConfig = environment.ccManagementPortalApiUrl + 'config/aap-cross-entity-bill';
    static ccHelpConfigBaseApiUrl = environment.ccManagementPortalApiUrl + 'config/cira-help';
    static ccTestPlanConfig = environment.ccManagementPortalApiUrl + 'test/assignment';
    static ccManagementReportConfigBaseApiUrl = environment.ccManagementPortalApiUrl + 'config/mgmt-report';

    static ccReportTemplateConfigBaseApiUrl = environment.ccManagementPortalApiUrl + 'config/report-template';
    static ccBatchJobEmailConfigBaseApiUrl = environment.ccManagementPortalApiUrl + 'config/batch-job-email';
    static ccMassCommunicationCongigBaseApiUrl = environment.ccManagementPortalApiUrl + 'config/mass-comm';
    static ccPrintingProviderCongigBaseApiUrl = environment.ccManagementPortalApiUrl + 'config/printing-provider';
    static ccWelcomeLetterConfigBaseApiUrl = environment.ccManagementPortalApiUrl + 'config/welcome-letter';

    static ccAmenityConfigBaseApiUrl = environment.ccManagementPortalApiUrl + 'config/amenity';
    static ccCiraBudgetConfigBaseApiUrl = environment.ccManagementPortalApiUrl + 'config/cira-budget';
    static ccWorkOrderWorkAreaBaseApiUrl = environment.ccManagementPortalApiUrl + 'config/work-order-work-area';
    static ccBudgetRuleConfigBaseApiUrl = environment.ccManagementPortalApiUrl + 'config/budget-rule';

    static ccServicesConfigBaseUrl = environment.ccManagementPortalApiUrl + 'config/service';
    static ccBrandingConfigBaseUrl = environment.ccManagementPortalApiUrl + 'config/branding';
    static ccResidentPortalConfigBaseUrl = environment.ccManagementPortalApiUrl + 'config/resident-portal';
    static ccServiceRoleConfigBaseUrl = environment.ccManagementPortalApiUrl + 'config/service-role';
    static ccServiceGroupConfigBaseUrl = environment.ccManagementPortalApiUrl + 'config/service-group';
    static ccBoardPortalConfigBaseUrl = environment.ccManagementPortalApiUrl + 'config/board-portal';
    static ccCalendarConfigBaseUrl = environment.ccManagementPortalApiUrl + 'config/calendar';

    static ccResponseTemplateBaseApiUrl = environment.ccManagementPortalApiUrl + 'config/response-templates';
    static ccBillingTypeConfigBaseApiUrl = environment.ccManagementPortalApiUrl + 'config/billing-type';

    static ccInternalTaskBaseApiUrl = environment.ccManagementPortalApiUrl + 'internaltask';
    static ccProjectTaskBaseApiUrl = environment.ccManagementPortalApiUrl + 'projecttask';
    static ccPrintStatementBaseApiUrl = environment.ccManagementPortalApiUrl + 'print-statement';
    static ccWelcomeLetterQueueBaseApiUrl = environment.ccManagementPortalApiUrl + 'welcome-letter';
    static ccCommunityCertifiedTracking = environment.ccManagementPortalApiUrl + 'community/certified-tracking';
    static ccCiramailEmailViewer = environment.ccManagementPortalApiUrl + 'emailviewer/';

    static ccTimeAndExpenseBaseUrl = environment.ccManagementPortalApiUrl + 'user/te';
    static ccTimeAndExpenseEmailConfirmationUrl = environment.ccManagementPortalApiUrl + 'te/email/submission';
    static ccSubmissionHistoryApiUrl = environment.ccManagementPortalApiUrl + 'te/submissions';
    static ccClosingRequestApiUrl = environment.ccManagementPortalApiUrl + 'closingrequest';
    static ccFulfillmentApiUrl = environment.ccManagementPortalApiUrl + 'fulfillment';
    static ccWorkOrderConfigApiUrl = environment.ccManagementPortalApiUrl + 'workorder';
    static ccAccApplicationBaseApiUrl = environment.ccManagementPortalApiUrl + 'acc';
    static ccWorkQueueEmailActionsUrl = environment.ccManagementPortalApiUrl + 'ccb/ap/work-queue/email-action';

    static ccBoardApprovalConfigApiUrl = environment.ccManagementPortalApiUrl + 'boardapproval';
    static ccCommunityBlocksApiUrl = environment.ccManagementPortalApiUrl + 'soa/community';

    static ccCBRMBillingItemApiUrl = environment.ccManagementPortalApiUrl + 'cb/rm/billingitem';
    static ccStatementApprovalApiUrl = environment.ccManagementPortalApiUrl + 'statementapproval';
    static ccPropertyConveyanceApiUrl = environment.ccManagementPortalApiUrl + 'conveyance';
    static ccWorkInboxBaseApiUrl = environment.ccManagementPortalApiUrl + 'workinbox';
    static ccCommunityResidentContactLogsBaseApiUrl =
        environment.ccManagementPortalApiUrl + 'community/log/residentcontact';

    static ccCBRMBillingQueueApiUrl = environment.ccManagementPortalApiUrl + 'cb/rm/billingqueue';
    static ccBankReturnsApiUrl = environment.ccManagementPortalApiUrl + 'bank-returns';
    static ccPaymentPostError = environment.ccManagementPortalApiUrl + 'payment-post-errors';

    static ccNocQueueApiUrl = environment.ccManagementPortalApiUrl + 'noc-queue';

    static ccVendorManagementBaseApiUrl = environment.ccManagementPortalApiUrl + 'vendormanagement';
    static ccVendorManagementElectronicPayment =
        environment.ccManagementPortalApiUrl + 'vendormanagement/electronicpayment';

    static ccLocationVendorBaseApiUrl = environment.ccManagementPortalApiUrl + 'vb';
    static ccManagementCompanyVendorBaseApiUrl = environment.ccManagementPortalApiUrl + 'vm';
    static ccCommonLotsApiUrl = environment.ccManagementPortalApiUrl + 'community/commonlots';
    static ccViolationApiBaseUrl = environment.ccManagementPortalApiUrl + 'violation';
    static ccViolationInspectionApiBaseUrl = environment.ccManagementPortalApiUrl + 'inspection';
    static ccAnnualCouponApiBaseUrl = environment.ccManagementPortalApiUrl + 'annual-coupon';
    static ccAddCommunityApiBaseUrl = environment.ccManagementPortalApiUrl + 'community/addCommunity';
    static ccOnBoardingFlagsApiBaseUrl = environment.ccManagementPortalApiUrl + 'community/onboarding/flags';

    static ccPtBaseApiUrl = environment.ccManagementPortalApiUrl + 'pt';
    static ccPtFrpBaseApiUrl = environment.ccManagementPortalApiUrl + 'pt/financial-report';
    static ccPtMrgBaseApiUrl = environment.ccManagementPortalApiUrl + 'pt/mgmnt-report';
    static ccPtSgBaseApiUrl = environment.ccManagementPortalApiUrl + 'pt/annual-stmnt';
    static ccPtCoBaseApiUrl = environment.ccManagementPortalApiUrl + 'pt/annual-coupon-order';
    static ccPtBpBaseApiUrl = environment.ccManagementPortalApiUrl + 'pt/annual-budget';
    static ccPtStBaseApiUrl = environment.ccManagementPortalApiUrl + 'pt/annual-state-tax';
    static ccPtStPrBaseApiUrl = environment.ccManagementPortalApiUrl + 'pt/annual-state-tax/step/aap-payment-request';
    static ccPtFtBaseApiUrl = environment.ccManagementPortalApiUrl + 'pt/annual-federal-tax';
    static ccPtFtPrBaseApiUrl = environment.ccManagementPortalApiUrl + 'pt/annual-federal-tax/step/aap-payment-request';
    static ccCommunityReportApiUrl = environment.ccManagementPortalApiUrl + 'community/report';
    static ccReportsMoveInsApiUrl = environment.ccManagementPortalApiUrl + 'community/reports';

    static ccCalendarBaseApiUrl = environment.ccManagementPortalApiUrl + 'calendar';

    static ccEmployeeManagementBaseApiUrl = environment.ccManagementPortalApiUrl + 'tools/employee';

    static ccDocumentPrintBaseApiUrl = environment.ccManagementPortalApiUrl + 'tools/documentprint';

    static ccLocationManagerBaseApiUrl = environment.ccManagementPortalApiUrl + 'location-manager';
    static ccCommunityCommunicationBaseApiUrl = environment.ccManagementPortalApiUrl + 'community/log';
    static ccCommunityInsuranceBaseApiUrl = environment.ccManagementPortalApiUrl + 'insurance';
    static ccCommunityAmenityBaseApiUrl = environment.ccManagementPortalApiUrl + 'community/amenity';
    static ccCommunityAnnouncementApiBaseUrl = environment.ccManagementPortalApiUrl + 'community/log/';
    static ccCommunityAchievementApiBaseUrl = environment.ccManagementPortalApiUrl + 'user';
    static ccCCBRMSetupBillingItemCategory = environment.ccManagementPortalApiUrl + 'ccb/rm/setup/bi-category';
    static ccCCBGLGeneralLedgerReport = environment.ccManagementPortalApiUrl + 'ccb/gl/report';
    static ccCCBGLGeneralLedger = environment.ccManagementPortalApiUrl + 'ccb/gl/';
    static ccCCBGLOpenCloseBooks = environment.ccManagementPortalApiUrl + 'ccb/entity/books';
    static ccCCBRMSetupProductSetup = environment.ccManagementPortalApiUrl + 'ccb/rm/setup/product';
    static ccCCBEntityAuditLog = environment.ccManagementPortalApiUrl + 'ccb/auditlog';
    static ccCCBRMBillingRulesSetup = environment.ccManagementPortalApiUrl + 'ccb/rm/setup/billing-rule';
    static ccCCBGLBudget = environment.ccManagementPortalApiUrl + 'ccb/gl/budget';
    static ccCCBGLUploadJournalEntry = environment.ccManagementPortalApiUrl + 'ccb/gl/je/upload';
    static ccCCBGLTrialBalance = environment.ccManagementPortalApiUrl + 'ccb/gl/trial-balance';

    static ccCCBConfiguration = environment.ccManagementPortalApiUrl + 'ccb/config';
    static ccCCBGLConfiguration = environment.ccManagementPortalApiUrl + 'ccb/config/gl';

    static ccCCBGLBaseAccountConfiguration = environment.ccManagementPortalApiUrl + 'ccb/config/gl/base-account';
    static ccCCBGLSubAccountConfiguration = environment.ccManagementPortalApiUrl + 'ccb/config/gl/sub-account';
    static ccCCBAccountGroupConfiguration = environment.ccManagementPortalApiUrl + 'ccb/config/gl/account-group';
    static ccCCBGLSubCategoryConfiguration = environment.ccManagementPortalApiUrl + 'ccb/config/gl/sub-category';
    static ccCCBGLDimensionConfiguration = environment.ccManagementPortalApiUrl + 'ccb/config/gl/dimension';
    static ccCCBGLAccountLabelConfiguration = environment.ccManagementPortalApiUrl + 'ccb/config/gl/account-label';
    static ccCCBDimensionGroupConfiguration = environment.ccManagementPortalApiUrl + 'ccb/config/gl/dimension-group';

    static ccCCBEntityConfiguration = environment.ccManagementPortalApiUrl + 'ccb/config/entity';
    static ccCCBEntityGeneralInfoConfiguration =
        environment.ccManagementPortalApiUrl + 'ccb/config/entity/general-info';
    static ccCCBEntityBillingEntityConfiguration =
        environment.ccManagementPortalApiUrl + 'ccb/config/entity/billing-entity';
    static ccCCBEntityAccountConfiguration = environment.ccManagementPortalApiUrl + 'ccb/config/entity/account-config';

    static ccAccountManagementApiBaseUrl = environment.ccManagementPortalApiUrl + 'acctmgmt';

    static ccCommunityCBRMSubscriptionBaseUrl = environment.ccManagementPortalApiUrl + 'cb/rm/setup/subscriptions';
    static ccTEMChargeRateCategorySetupBaseUrl = environment.ccManagementPortalApiUrl + 'ccb/te/charge-rate-category';
    static ccCommunityCBRMCustomerContractBaseUrl = environment.ccManagementPortalApiUrl + 'cb/rm/customer-contract';
    static ccTEMChargeRateSetupBaseUrl = environment.ccManagementPortalApiUrl + 'ccb/te/charge-rate';
    static ccTEMChargeCodeCategorySetupBaseUrl = environment.ccManagementPortalApiUrl + 'ccb/te/charge-code-category';
    static ccbTEMChargeCodeSetupBaseUrl = environment.ccManagementPortalApiUrl + 'ccb/te/charge-code';

    static ccMyTextBaseApiUrl = environment.ccManagementPortalApiUrl + 'text';
    static ccCCBARBaseApiUrl = environment.ccManagementPortalApiUrl + 'ccb/ar';
    static ccCCBARCustomerAgingApiUrl = environment.ccManagementPortalApiUrl + 'ccb/ar/aging';
    static ccCCBCustomerApiBaseUrl = environment.ccManagementPortalApiUrl + 'ccb/customer';
    static ccCCBARLedgerBaseurl = environment.ccManagementPortalApiUrl + 'ccb/ar/ledger';
    static ccCCBARAdjustmentApiUrl = environment.ccManagementPortalApiUrl + 'ccb/ar/adjustment';
    static ccCCBARPaymentApiUrl = environment.ccManagementPortalApiUrl + 'ccb/ar/payment';
    static ccCCBARInvoiceApiUrl = environment.ccManagementPortalApiUrl + 'ccb/ar/invoice';
    static ccCCBJournalEntriesApiUrl = environment.ccManagementPortalApiUrl + 'ccb/gl/je';
    static ccCCBGLBatchSummaryApiUrl = environment.ccManagementPortalApiUrl + 'ccb/gl/batch';
    static ccCCBJournalEntryTemplateApiUrl = environment.ccManagementPortalApiUrl + 'ccb/gl/jet';

    static ccCCBCashReciptApiUrl = environment.ccManagementPortalApiUrl + 'ccb/cm/cr';

    static ccCCBAPLedgerBaseurl = environment.ccManagementPortalApiUrl + 'ccb/ap/ledger';
    static ccCCBWorkQueueManagementurl = environment.ccManagementPortalApiUrl + 'ccb/ap/work-queue';
    static ccCCBAPAdjustmentBaseUrl = environment.ccManagementPortalApiUrl + 'ccb/ap/adjustment';
    static ccCCBAPPaymentBaseUrl = environment.ccManagementPortalApiUrl + 'ccb/ap/payment';
    static ccCCBAPVendorManagementBaseUrl = environment.ccManagementPortalApiUrl + 'ccb/ap/vendor-mgmt';
    static ccCCBTEMPayrollReimbursementsBaseUrl = environment.ccManagementPortalApiUrl + 'te/payroll';
    static ccCCBArInvoiceAnalysisBaseUrl = environment.ccManagementPortalApiUrl + 'ccb/ar/invoiceAnalysis';
    static ccCCBAPCreditApplicationBaseUrl = environment.ccManagementPortalApiUrl + 'ccb/ap/credit-application';
    static ccCCBVendor1099BaseUrl = environment.ccManagementPortalApiUrl + 'ccb/ap/vendor-1099';
    static ccCCBAPBillAnalysisBaseurl = environment.ccManagementPortalApiUrl + 'ccb/ap/bill-analysis';
    static ccCCBVendorAgingBaseUrl = environment.ccManagementPortalApiUrl + 'ccb/ap/vendor-aging';
    static ccCCBCheckPrintingBillToPayBaseUrl = environment.ccManagementPortalApiUrl + 'ccb/check-printing/bill-to-pay';
    static ccCCBCheckPrintingPaidCheckBaseUrl = environment.ccManagementPortalApiUrl + 'ccb/check-printing/paid-check';

    static ccCCBEFTPaymentManagementBaseUrl = environment.ccManagementPortalApiUrl + 'ccb/ap/eft-mgmt';

    static ccCCBCMDepositsBaseUrl = environment.ccManagementPortalApiUrl + 'ccb/cm/deposit';
    static ccCCBBatchBaseUrl = environment.ccManagementPortalApiUrl + 'ccb/batch';
    static ccCCBCMBankReconciliation = environment.ccManagementPortalApiUrl + 'ccb/cm/ba/bank-rec';
    static ccCCBReportsBaseUrl = environment.ccManagementPortalApiUrl + 'ccb/report';
    static ccCCBBankAccountsConfigurationBaseUrl = environment.ccManagementPortalApiUrl + 'ccb/cm/ba';
    static ccTestingConfigurationBaseUrl = environment.ccManagementPortalApiUrl + 'test-config';
}
